module.exports = __webpack_public_path__ + "static/media/ruv-logo.0cab321b.jpg";